import { AxiosResponse } from 'axios'

import { _axios } from './axios'

// 型定義
export type InstructionAISummary = {
  id: string
  securityId: string
  status: number
  recentSituation: string
  nextCheckPoints: string
  longTermTrend: string
  latestRecordDate?: string
  generatedAt?: string
}

export type PendingSummary = {
  summary: InstructionAISummary
  companyName: string
  companyBranchName: string
  securityName: string
}

export type GetPendingResponse = {
  summaries: PendingSummary[]
}

export type UpdateSummaryRequest = {
  recentSituation: string
  nextCheckPoints: string
  longTermTrend: string
}

export type RelatedRecord = {
  instructionRecordId: string
  instructedOn: string
  instructor: string
  place: string
  instructionNote: string
  privateNote: string
}

export type GetRelatedRecordsResponse = {
  records: RelatedRecord[]
}

// ステータス定数
export const SUMMARY_STATUS = {
  GENERATING: 1,
  PENDING: 2,
  PUBLISHED: 3,
  FAILED: 4,
  REJECTED: 5,
} as const

// エンドポイント
const PENDING = '/instruction-summary/pending'
const RECENT_PUBLISHED = '/instruction-summary/recent-published'
const PUBLISH = (id: string) => `/instruction-summary/${id}/publish`
const UNPUBLISH = (id: string) => `/instruction-summary/${id}/unpublish`
const REJECT = (id: string) => `/instruction-summary/${id}/reject`
const UPDATE = (id: string) => `/instruction-summary/${id}`
const RECORDS = (id: string) => `/instruction-summary/${id}/records`

export const instructionSummaryApi = () => {
  // 確認待ちサマリ一覧取得
  const getPending = async (): Promise<AxiosResponse<GetPendingResponse>> => {
    return await _axios().get(PENDING)
  }

  // 直近公開サマリ一覧取得
  const getRecentPublished = async (): Promise<
    AxiosResponse<GetPendingResponse>
  > => {
    return await _axios().get(RECENT_PUBLISHED)
  }

  // サマリ公開
  const publish = async (id: string): Promise<AxiosResponse<void>> => {
    return await _axios().post(PUBLISH(id))
  }

  // サマリ公開取り消し
  const unpublish = async (id: string): Promise<AxiosResponse<void>> => {
    return await _axios().post(UNPUBLISH(id))
  }

  // サマリ却下
  const reject = async (id: string): Promise<AxiosResponse<void>> => {
    return await _axios().post(REJECT(id))
  }

  // サマリ編集
  const update = async (
    id: string,
    data: UpdateSummaryRequest,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().patch(UPDATE(id), data)
  }

  // 関連記録取得
  const getRelatedRecords = async (
    id: string,
  ): Promise<AxiosResponse<GetRelatedRecordsResponse>> => {
    return await _axios().get(RECORDS(id))
  }

  return {
    getPending,
    getRecentPublished,
    publish,
    unpublish,
    reject,
    update,
    getRelatedRecords,
  }
}
